export default __webpack_public_path__ + "locales/fi/About.json?hash=f497b3a3aee4dda32347babbfde5a225";